import * as React from 'react';
import { Typography } from '@/components/common';
import { CaseMetricsPyramid } from './CaseMetricsPyramid';
import { ClientAcquisitionFunnelResult } from '@/interfaces';
import useDeviceWidth from '@/hooks/useDeviceWidth';
import clsx from 'clsx';
import { CaseMetricsShortPyramid } from './CaseMetricsShortPyramid';

interface clientAcquisitionListI {
	amount: number;
	title: string;
}

export const CaseMetricsClientAcquisition = ({
	clientAcquisition,
	isDocumentRequired,
	isCaseLive,
}: {
	clientAcquisition: ClientAcquisitionFunnelResult[];
	isDocumentRequired: boolean | null | undefined;
	isCaseLive: boolean | undefined;
}) => {
	const [clientAcquisitionList, setClientAcquisitionList] = React.useState<
		clientAcquisitionListI[]
	>([]);
	const width = useDeviceWidth();

	const showShortPyramid = !isDocumentRequired && isCaseLive;

	React.useEffect(() => {
		let clientAcquisitionList: clientAcquisitionListI[] = [
			{
				amount: clientAcquisition[0].claim_submission,
				title: 'Claim Submission',
			},
			{
				amount: clientAcquisition[0].preliminary_auto_approval,
				title: 'Preliminary Auto-Approval ',
			},
			{
				amount: clientAcquisition[0].client_documentation_received,
				title: 'Client Documentation Received',
			},
			{
				amount: clientAcquisition[0].claim_approved,
				title: 'Claim Approved',
			},
			{
				amount: clientAcquisition[0].signed_retainer,
				title: 'Signed Retainer',
			},
		];

		if (showShortPyramid) {
			clientAcquisitionList = [
				{
					amount: clientAcquisition[0].claim_submission,
					title: 'Claim Submission',
				},
				{
					amount: clientAcquisition[0].claim_approved,
					title: 'Auto-Approval ',
				},
				{
					amount: clientAcquisition[0].signed_retainer,
					title: 'Signed Retainer',
				},
			];
		}

		setClientAcquisitionList(clientAcquisitionList);
	}, [showShortPyramid]);

	return (
		<>
			{width > 1024 ? (
				<ul className="flex flex-col lg:flex-row  pl-5 relative min-h-[329px]">
					<div className="w-full mt-4">
						{clientAcquisitionList.map((item, index) => (
							<li key={'title' + item.title + index}>
								{showShortPyramid ? (
									<Typography
										type="semibold-12"
										className={clsx(
											'text-grey-80 relative border-b border-[#0D061614]',
											{
												'pb-10 mb-11 mt-5': index === 0,
												'pb-10 mb-11': index === 1,
												'pb-10': index === 2,
											}
										)}
									>
										{item.title}
									</Typography>
								) : (
									<Typography
										type="semibold-12"
										className={clsx(
											'text-grey-80 relative border-b border-[#0D061614]',
											{
												'pb-[1.563rem] mb-6': index === 0,
												'pb-6 mb-[1.469rem]': index === 1,
												'pb-4 mb-[1.438rem]': index === 2,
												'pb-5 mb-[1.281rem]': index === 3,
												'pb-[1.281rem]': index === 4,
											}
										)}
									>
										{item.title}
									</Typography>
								)}
							</li>
						))}
					</div>
					<div
						className="lg:absolute lg:right-0 top-0"
						style={{
							clipPath: showShortPyramid
								? 'polygon(-30% 0%, 100% 0, 100% 100%, 40% 100%)'
								: 'polygon(-40px 0, 100% 0, 100% 100%, 40% 100%)',
							overflow: 'hidden',
						}}
					>
						{clientAcquisitionList.map((item, index) => (
							<li
								key={'level' + item.title + index}
								className="flex justify-center items-center bg-white pr-4"
							>
								{showShortPyramid ? (
									<CaseMetricsShortPyramid
										level={index.toString()}
										amount={item.amount}
									/>
								) : (
									<CaseMetricsPyramid
										level={index.toString()}
										amount={item.amount}
									/>
								)}
							</li>
						))}
					</div>
				</ul>
			) : (
				<div className="flex flex-col px-4">
					<div className="w-full">
						{clientAcquisitionList.map((item, index) => (
							<div
								key={'title' + item.title + index}
								className="flex py-[14px] items-center justify-between border-b border-[#0D061614]"
							>
								<Typography
									type="semibold-12"
									className="text-grey-80 text-start max-w-[160px]"
								>
									{item.title}
								</Typography>
								<Typography
									type="semibold-20"
									className="text-[#322935] !text-[20px] !leading-[24px]"
								>
									{item.amount || '0'}
								</Typography>
							</div>
						))}
					</div>
				</div>
			)}
		</>
	);
};
